import { Link } from 'react-router-dom'
import { AlertTriangle, CalendarClock, ShieldCheck } from 'lucide-react'

// Módulo planejado — nada aqui está funcionando ainda.
// As regras de segurança já estão definidas para quando for implementado.
export default function AgendaIaPage() {
  return (
    <div>
      <header style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div
            aria-hidden
            style={{
              width: 38, height: 38, borderRadius: 10, background: 'var(--primary-soft)',
              color: 'var(--primary-deep)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <CalendarClock size={19} />
          </div>
          <div>
            <h1 className="page-title">Agenda IA</h1>
            <p className="page-subtitle" style={{ margin: 0 }}>Agendamento assistido pelo WhatsApp.</p>
          </div>
        </div>
      </header>

      <div className="badge badge-warn" style={{ display: 'block', padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>
        <AlertTriangle size={13} aria-hidden /> Módulo ainda não implementado — esta tela descreve o que ele fará e as
        regras que já valem no sistema.
      </div>

      <section className="card" style={{ padding: 18, marginBottom: 14 }}>
        <strong style={{ fontSize: 15, display: 'block', marginBottom: 8 }}>O que a Agenda IA vai fazer</strong>
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8, fontSize: 14, color: 'var(--text-secondary)' }}>
          <li>Entender pedidos de horário que chegam pelo WhatsApp e propor opções livres da agenda.</li>
          <li>Confirmar e lembrar consultas, respeitando a janela de 24h e usando template fora dela.</li>
          <li>Reconhecer pedidos de remarcação e cancelamento e encaminhá-los à secretária.</li>
          <li>Cobrar a preparação (pré-anamnese, exames, termos) das consultas que não estão prontas.</li>
        </ul>
      </section>

      <section className="card" style={{ padding: 18, marginBottom: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <ShieldCheck size={17} aria-hidden style={{ color: 'var(--ok)' }} />
          <strong style={{ fontSize: 15 }}>Limites que já estão no sistema</strong>
        </div>
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8, fontSize: 14, color: 'var(--text-secondary)' }}>
          <li>A IA <strong>nunca conclui um agendamento sozinha</strong>: proposta passa por pessoa antes de virar consulta.</li>
          <li>A IA <strong>nunca encerra o atendimento</strong> nem responde questão clínica — isso é entregue a humano.</li>
          <li>Disparos automáticos vêm <strong>desligados por padrão</strong> e respeitam o teto por hora.</li>
          <li>A chave-mestra do WhatsApp derruba qualquer envio, inclusive o da IA.</li>
          <li>Toda mensagem gerada por IA é identificada como tal e fica na trilha de auditoria.</li>
        </ul>
        <div style={{ marginTop: 12 }}>
          <Link to="/configuracoes/whatsapp" className="btn-secondary">Ver chave-mestra e limites</Link>
        </div>
      </section>

      <p style={{ fontSize: 13.5, color: 'var(--muted)' }}>
        Quer que eu implemente este módulo? Ele depende de definir os horários que a IA pode oferecer e quem aprova
        cada agendamento.
      </p>
    </div>
  )
}
